export enum CustomerSiteContractType {
  bipartite = 'BIPARTITE',
  tripartite = 'TRIPARTITE',
}
